"use client"
import { PopupLayout } from "@/components/common/popup/layout/PopupLayout"

interface BookshelfAnalysisCompletePopupProps {
  onConfirm: () => void
}

const BookshelfAnalysisCompletePopup = ({
  onConfirm,
}: BookshelfAnalysisCompletePopupProps) => {
  return (
    <PopupLayout
      title="책장 도서 확인 알림"
      buttons={[{ title: "확인", onClick: onConfirm }]}
    >
      <p className="typo-rl-body2 text-rl-gray-font-caption text-center font-normal">
        촬영한 책장의 도서 정보를
        <br />
        모두 확인하였습니다.
        <br />
        책장 도서 등록을 완료해 주세요.
      </p>
    </PopupLayout>
  )
}

export default BookshelfAnalysisCompletePopup
